/* ============================================================
   ANORA 定制脚本  (2026-09-11，2026-09-13 按店主反馈重做①③⑤)
   需求来源：d:\飞书\上线优化内容0909.docx
   接入：layout/theme.liquid </head> 前一行 <script defer>
   —— 删掉那一行即可整体撤销

   ① 手机端吸底条：Add to cart + Buy it now 两个按钮（参考 ilikehair 手机版）
      真按钮滚出视口上方才出现；菜单/购物车抽屉打开时藏起
   ② 星级评论数加下划线 + 点击跳转到评论区
   ③ 描述区 Product Details 那组规格：手机端 ± 折叠
   ⑤ 描述区 5 段长文案 → 就地收进 "Why You'll Like It"（✓ + 粗体小标题 + 原文），
      标题行带 ±，手机默认收起、桌面默认展开；文案一字不动

   通用原则：
     - 全部幂等，重复调用不会重复插入（Dawn 换变体会重渲染 section）
     - 只加类、包一层，不改主题原有文件
   ============================================================ */
(function () {
  'use strict';

  var MOBILE = window.matchMedia('(max-width: 749px)');
  var WL_TITLE = "Why You'll Like It";
  var CHECK_SVG =
    '<svg viewBox="0 0 14 14" width="14" height="14" focusable="false">' +
    '<path d="M2 7.4 5.2 10.6 12 3.8" fill="none" stroke="currentColor" stroke-width="1.8" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---------- 小工具 ---------- */
  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }
  function cleanText(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }
  function keyActivates(e) {
    return e.key === 'Enter' || e.key === ' ';
  }

  /* ============================================================
     ② 星级评论下划线 + 点击跳转
     Judge.me 是异步注入的 app block，所以要等它出现再挂。
     只有确实带数字（有评论）才加下划线，"No reviews" 不加。
     ============================================================ */
  function reviewTarget() {
    return (
      $('#judgeme_product_reviews') ||
      $('.jdgm-rev-widg') ||
      $('.jdgm-widget.jdgm-review-widget') ||
      $('[id^="shopify-block-"] .jdgm-widget.jdgm-review-widget')
    );
  }
  function scrollToReviews() {
    var target = reviewTarget();
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.pageYOffset - 70;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function initReviewLink() {
    var badge = $('.jdgm-widget.jdgm-preview-badge');
    if (!badge) return false;
    var txt = $('.jdgm-prev-badge__text', badge);
    if (!txt) return false;

    var hasCount = /\d/.test(txt.textContent || '');
    txt.classList.toggle('anora-jdgm-linked', hasCount);
    if (!hasCount) return true;

    if (badge.dataset.anoraLinked === '1') return true;
    badge.dataset.anoraLinked = '1';

    badge.addEventListener('click', function (e) {
      if (!reviewTarget()) return;
      e.preventDefault();
      scrollToReviews();
    });
    badge.setAttribute('role', 'link');
    badge.setAttribute('tabindex', '0');
    badge.addEventListener('keydown', function (e) {
      if (keyActivates(e)) {
        e.preventDefault();
        badge.click();
      }
    });
    return true;
  }

  /* ============================================================
     描述区实际结构（已核对渲染 HTML）：
       .product__description
         ├ div.purchase_info            ← 开头零散行
         ├ h3.purchase_info             ← "Product Details"
         ├ div.purchase_info × N        ← 规格行
         └ div.purchase_info            ← 里面是 5 组 <h3>+<p> 长文案  ← ⑤ 改造对象
     ============================================================ */

  // 把一个容器的直接子元素按 h3 分组：h3 为头，后续兄弟为体
  function buildGroups(container, keepEmpty) {
    var groups = [];
    var cur = null;
    $$(':scope > *', container).forEach(function (el) {
      if (el.tagName === 'H3') {
        cur = { head: el, body: [] };
        groups.push(cur);
        return;
      }
      // 自己内部还有 h3 的兄弟（或已改造过的块）属于另一层，不并进本组
      if (el.hasAttribute('data-anora-wl') || (el.querySelector && el.querySelector('h3'))) {
        cur = null;
        return;
      }
      if (cur) cur.body.push(el);
    });
    return keepEmpty
      ? groups
      : groups.filter(function (g) {
          return g.body.length > 0;
        });
  }

  /* 展开/收起的滑动效果：高度 + 上下内边距一起过渡，收完再交给 .anora-acc-hidden 隐藏。
     初始化时传 animate=false，页面一进来不该有动画 */
  var ACC_MS = 280;
  function slideEl(el, open, animate) {
    if (!el) return;
    var prev = el.__anoraSlide;
    if (prev) {
      el.removeEventListener('transitionend', prev.onEnd);
      clearTimeout(prev.timer);
      el.__anoraSlide = null;
    }
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!animate || reduce) {
      el.style.transition = el.style.height = el.style.overflow = el.style.boxSizing = '';
      el.style.paddingTop = el.style.paddingBottom = '';
      el.classList.toggle('anora-acc-hidden', !open);
      return;
    }
    var cs = window.getComputedStyle(el);
    var padTop = cs.paddingTop;
    var padBottom = cs.paddingBottom;
    // 先还原成完全展开的样子量一次高度（getBoundingClientRect 拿到的是含内边距的 border-box 高）
    el.classList.remove('anora-acc-hidden');
    el.style.transition = 'none';
    el.style.boxSizing = 'border-box';
    el.style.overflow = 'hidden';
    el.style.height = 'auto';
    el.style.paddingTop = padTop;
    el.style.paddingBottom = padBottom;
    var full = el.getBoundingClientRect().height;
    el.style.height = (open ? 0 : full) + 'px';
    el.style.paddingTop = open ? '0px' : padTop;
    el.style.paddingBottom = open ? '0px' : padBottom;
    void el.offsetHeight; // 强制刷新，否则下面的赋值会和上面合并成一步，动画不跑
    el.style.transition = 'height ' + ACC_MS + 'ms ease, padding ' + ACC_MS + 'ms ease';
    el.style.height = (open ? full : 0) + 'px';
    el.style.paddingTop = open ? padTop : '0px';
    el.style.paddingBottom = open ? padBottom : '0px';
    var state = {};
    function finish() {
      el.removeEventListener('transitionend', state.onEnd);
      clearTimeout(state.timer);
      el.style.transition = el.style.height = el.style.overflow = el.style.boxSizing = '';
      el.style.paddingTop = el.style.paddingBottom = '';
      if (!open) el.classList.add('anora-acc-hidden');
      el.__anoraSlide = null;
    }
    state.onEnd = function (e) {
      if (e.target !== el || e.propertyName !== 'height') return;
      finish();
    };
    // transitionend 偶尔不触发（后台标签页、元素被重渲染），留个兜底
    state.timer = setTimeout(finish, ACC_MS + 120);
    el.__anoraSlide = state;
    el.addEventListener('transitionend', state.onEnd);
  }

  /* ---------- ③ 规格组：手机端 ± 折叠（桌面端释放） ---------- */
  function wireSpecGroup(g) {
    var head = g.head;
    if (head.dataset.anoraAcc === '1') return;
    head.dataset.anoraAcc = '1';

    head.classList.add('anora-acc-head');
    head.setAttribute('role', 'button');
    head.setAttribute('tabindex', '0');

    var icon = document.createElement('span');
    icon.className = 'anora-acc-icon';
    icon.setAttribute('aria-hidden', 'true');
    head.appendChild(icon);

    g.body.forEach(function (el) {
      el.classList.add('anora-acc-body');
    });

    function setOpen(open, animate) {
      head.classList.toggle('anora-acc-closed', !open);
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
      g.body.forEach(function (el) {
        slideEl(el, open, animate);
      });
      head.dataset.anoraOpen = open ? '1' : '0';
    }
    head.__anoraSetOpen = setOpen;

    function toggle() {
      setOpen(head.dataset.anoraOpen !== '1', true);
    }
    head.addEventListener('click', toggle);
    head.addEventListener('keydown', function (e) {
      if (keyActivates(e)) {
        e.preventDefault();
        toggle();
      }
    });
    setOpen(true, false); // 规格是关键信息，默认展开
  }

  // 桌面端不折叠规格：把内容全部释放，视觉回到原样
  // 两端一致：电脑端以前会把 ± 藏掉、强制展开（下面这些 style 是那时留下的），
  // 店主要求电脑端也能收起，这里只负责把旧的行内样式清干净，不再按断点区别对待
  function applyAccMode() {
    $$('.anora-acc-head').forEach(function (head) {
      head.style.display = '';
      head.style.cursor = '';
      head.style.borderBottom = '';
      var icon = $('.anora-acc-icon', head);
      if (icon) icon.style.display = '';
    });
  }

  /* ---------- ⑤ 5 段长文案 → Why You'll Like It ---------- */
  function buildWhyLike(box) {
    if (box.dataset.anoraWl === '1') return;
    var groups = buildGroups(box, true);
    if (!groups.length) return;
    box.dataset.anoraWl = '1';

    var wrap = document.createElement('div');
    wrap.className = 'anora-wl';
    wrap.setAttribute('data-anora-wl', '');

    var head = document.createElement('div');
    head.className = 'anora-wl__head';
    head.setAttribute('role', 'button');
    head.setAttribute('tabindex', '0');
    // 和 Product Details 那一行同结构 <h3><strong>：那一行的粗体来自商品描述里自带的 <strong>，
    // 只用 h3 的话主题给的是 400，两行一粗一细
    var title = document.createElement('h3');
    title.className = 'anora-wl__title';
    var titleText = document.createElement('strong');
    titleText.textContent = WL_TITLE;
    title.appendChild(titleText);
    var icon = document.createElement('span');
    icon.className = 'anora-acc-icon';
    icon.setAttribute('aria-hidden', 'true');
    head.appendChild(title);
    head.appendChild(icon);

    var list = document.createElement('ul');
    list.className = 'anora-wl__list';

    groups.forEach(function (g) {
      var point = cleanText(g.head);
      // 说明文字连同后台加的粗体/斜体/链接一起搬过来（只取文字会把 <strong> 丢掉）
      var bodies = g.body.filter(function (el) {
        return cleanText(el);
      });
      if (!point && !bodies.length) return;

      var li = document.createElement('li');
      li.className = 'anora-wl__item';

      var check = document.createElement('span');
      check.className = 'anora-wl__check';
      check.setAttribute('aria-hidden', 'true');
      check.innerHTML = CHECK_SVG;

      var text = document.createElement('span');
      text.className = 'anora-wl__text';
      if (point) {
        var strong = document.createElement('strong');
        strong.className = 'anora-wl__point';
        strong.textContent = point;
        text.appendChild(strong);
      }
      if (bodies.length) {
        var span = document.createElement('span');
        span.className = 'anora-wl__detail';
        if (point) span.appendChild(document.createTextNode(' \u2014 '));
        bodies.forEach(function (el, i) {
          if (i) span.appendChild(document.createTextNode(' '));
          Array.prototype.forEach.call(el.childNodes, function (n) {
            span.appendChild(n.cloneNode(true));
          });
        });
        text.appendChild(span);
      }
      li.appendChild(check);
      li.appendChild(text);
      list.appendChild(li);
    });

    wrap.appendChild(head);
    wrap.appendChild(list);

    // 原来的 h3/p 由新块替代（文案已原样搬进 li）
    while (box.firstChild) box.removeChild(box.firstChild);
    box.appendChild(wrap);

    function setOpen(open, animate) {
      head.classList.toggle('anora-acc-closed', !open);
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
      slideEl(list, open, animate);
    }
    head.addEventListener('click', function () {
      setOpen(head.classList.contains('anora-acc-closed'), true);
    });
    head.addEventListener('keydown', function (e) {
      if (keyActivates(e)) {
        e.preventDefault();
        head.click();
      }
    });
    // 两端都默认展开：店主要求第一眼就能看到内容
    setOpen(true, false);
  }

  function initDescription() {
    var desc = $('.product__description');
    if (!desc) return false;

    if (desc.dataset.anoraAccInit !== '1') {
      desc.dataset.anoraAccInit = '1';
      // 顶层：规格组
      buildGroups(desc).forEach(wireSpecGroup);
      // 嵌套：含 h3 的子容器 → Why You'll Like It
      $$(':scope > *', desc).forEach(function (box) {
        if (box.tagName !== 'H3' && box.querySelector && box.querySelector('h3')) {
          buildWhyLike(box);
        }
      });
    }
    applyAccMode();
    return true;
  }

  /* ============================================================
     ① 手机端吸底条（参考 ilikehair 手机版：两个按钮）
     - 代理真实按钮：.product-form__submit / .shopify-payment-button__button，
       变体、售罄、校验全部走主题原生
     - 真按钮还在视野里（页面顶端）时不出现
     - 触发：scroll / touchmove / resize / IntersectionObserver，再加一个
       400ms 定时兜底 —— 不依赖任何单一事件，什么机型都能出来
     - Dawn 打开菜单/购物车抽屉时 body 会带 overflow-hidden*，此时藏起
     ============================================================ */
  var stickyBar = null;
  var stickyBound = false;

  function realSubmit() {
    return $('product-form .product-form__submit, .product-form__buttons .product-form__submit');
  }
  function realBuyNow() {
    return $('product-form .shopify-payment-button__button, .product-form__buttons .shopify-payment-button__button');
  }
  function overlayOpen() {
    return document.body.className.indexOf('overflow-hidden') >= 0;
  }

  /* 这家店的动态结账按钮是 PayPal 的跨域 iframe（zoid），没法代理点击。
     所以 Buy it now 自己做：把当前表单（变体+数量）加进购物车，成功后直达结账。 */
  var buying = false;
  function buyNowViaForm() {
    var btn = realSubmit();
    var form = btn && btn.form;
    if (!form || btn.disabled || buying) return;
    buying = true;
    var sBin = $('.anora-sticky-bin', stickyBar);
    var label = sBin.textContent;
    sBin.textContent = '...';
    var fd = new FormData(form);
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'add failed');
        });
      })
      .then(function () {
        window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'checkout';
      })
      .catch(function () {
        // 加购失败（比如需要先选变体）就退回真按钮，让主题原生提示接手
        buying = false;
        sBin.textContent = label;
        btn.click();
      });
  }

  function buildStickyBar() {
    if (stickyBar && document.body.contains(stickyBar)) return stickyBar;

    var bar = document.createElement('div');
    bar.id = 'anora-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<button type="button" class="anora-sticky-btn anora-sticky-atc">Add to cart</button>' +
      '<button type="button" class="anora-sticky-btn anora-sticky-bin">Buy it now</button>';
    document.body.appendChild(bar);

    $('.anora-sticky-atc', bar).addEventListener('click', function () {
      var b = realSubmit();
      if (b && !b.disabled) b.click();
    });
    $('.anora-sticky-bin', bar).addEventListener('click', function () {
      var b = realBuyNow();
      if (b && !b.disabled) {
        b.click();
        return;
      }
      buyNowViaForm();
    });

    stickyBar = bar;
    return bar;
  }

  function syncStickyBar() {
    if (!stickyBar) return;
    var btn = realSubmit();
    var bin = realBuyNow();
    var sAtc = $('.anora-sticky-atc', stickyBar);
    var sBin = $('.anora-sticky-bin', stickyBar);

    if (btn) {
      var span = $('span', btn);
      sAtc.textContent = cleanText(span || btn) || 'Add to cart';
      sAtc.disabled = !!btn.disabled;
    }
    // 第二个按钮永远是 Buy it now：有原生按钮就跟它的状态，没有就跟 Add to cart 的状态
    sBin.disabled = bin ? !!bin.disabled || !!(btn && btn.disabled) : !!(btn && btn.disabled);
    if (!buying) sBin.textContent = 'Buy it now';
  }

  /* Shopify 预览未发布主题时，底部会插一条它自己的"预览条"（PBarNextFrame，68px，
     层级最高），会把吸底条整个压住 —— 店主用预览链接在手机上看就是这么"看不见"的。
     检测到就把吸底条抬到它上方；上线后没有预览条，offset 自然为 0。 */
  function bottomOverlayHeight() {
    var h = 0;
    $$('#PBarNextFrameWrapper, [id*="PBarNextFrame"], [class*="PBarNextFrame"], #preview-bar-iframe').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') return;
      var r = el.getBoundingClientRect();
      // 只认贴在底部的"条"：预览条外面还套着一个全屏高的容器，不能把它算进去
      if (r.height > 0 && r.height < window.innerHeight * 0.4 && r.bottom >= window.innerHeight - 2) {
        h = Math.max(h, r.height);
      }
    });
    return Math.round(h);
  }

  function updateSticky() {
    if (!stickyBar) return;
    var btn = realSubmit();
    if (!btn) return;
    var show = MOBILE.matches && btn.getBoundingClientRect().bottom < 0 && !overlayOpen();
    var off = show ? bottomOverlayHeight() : 0;
    stickyBar.style.bottom = off ? off + 'px' : '';
    stickyBar.classList.toggle('anora-sticky-on', show);
    stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.body.classList.toggle('anora-sticky-pad', show);
  }

  var stickyTick = 0;
  function onScroll() {
    var now = Date.now();
    if (now - stickyTick < 60) return;
    stickyTick = now;
    updateSticky();
    updateMobileTabs();
  }

  function initStickyAtc() {
    var btn = realSubmit();
    if (!btn) return false;

    buildStickyBar();
    syncStickyBar();

    if (!stickyBound) {
      stickyBound = true;
      ['scroll', 'touchmove', 'resize', 'orientationchange'].forEach(function (ev) {
        window.addEventListener(ev, onScroll, { passive: true });
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(updateSticky, { threshold: 0 });
        io.observe(btn);
      }
      setInterval(updateSticky, 400); // 兜底：不依赖任何事件
    }
    updateSticky();
    return true;
  }

  /* ============================================================
     ④ 评论画廊 + 关键词筛选（2026-09-13 按店主反馈重做）
     数据来源：直接调 Judge.me 自己的翻页接口 reviews_for_widget，
     per_page=100 一次拿全部评论（它页面上的 Load More 用的就是这个接口）。
     关键词按评论正文匹配，得到真实条数。
       · 上面画廊：只"展示"关键词 + 条数（后台可改成点击=跳转并筛选）
       · 评论区：列表正上方插一排筛选按钮，就地筛选，不再跳来跳去
     接口拿不到时：画廊退回从页面 DOM 抓图、关键词只显示名字、不出筛选条。
     ============================================================ */
  var RF = { active: 'all', cfg: null, reviews: null, promise: null, waiting: false, takeover: false, shown: 0, ensureTimers: [] };
  var JDGM_API = 'https://api.judge.me/reviews/reviews_for_widget';

  function rgConfig() {
    var box = $('[data-anora-rg]');
    if (!box) return null;
    var d = box.dataset;
    var raw = d.anoraKeywords || '';
    var lines = raw.split(/\r?\n|;/);
    if (lines.length === 1 && raw.indexOf('=') < 0) lines = raw.split(','); // 兼容旧的逗号格式
    var kws = [];
    lines.forEach(function (line) {
      var eq = line.indexOf('=');
      var label = (eq < 0 ? line : line.slice(0, eq)).trim();
      if (!label || /^all$/i.test(label)) return;
      var terms = (eq < 0 ? label : line.slice(eq + 1))
        .split(',')
        .map(function (s) { return s.trim(); })
        .filter(Boolean);
      if (!terms.length) terms = [label];
      var esc = terms.map(function (t) { return t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
      kws.push({
        key: 'k' + kws.length,
        label: label,
        re: new RegExp('(^|[^a-z0-9])(' + esc.join('|') + ')(?![a-z0-9])', 'i'),
        reAll: new RegExp('(^|[^a-z0-9])(' + esc.join('|') + ')(?![a-z0-9])', 'ig'),
        count: 0
      });
    });
    return {
      box: box,
      keywords: kws,
      chipAction: d.anoraChipAction || 'display',
      showCounts: d.anoraShowCounts !== 'false',
      maxChips: parseInt(d.anoraMaxChips || '4', 10) || 4,
      filterBar: d.anoraFilterBar !== 'false',
      photosFilter: d.anoraPhotosFilter !== 'false',
      allLabel: d.anoraAllLabel || 'All',
      photosLabel: d.anoraPhotosLabel || 'With Photos',
      photosCount: 0
    };
  }

  function jdgmWidget() {
    return $('#judgeme_product_reviews') || $('.jdgm-widget.jdgm-review-widget');
  }
  function jdgmParams() {
    try {
      if (window.jdgm && typeof window.jdgm.shopParams === 'function') return window.jdgm.shopParams();
    } catch (e) { /* 走下面的兜底 */ }
    var shop = window.Shopify && window.Shopify.shop;
    return shop ? { url: shop, shop_domain: shop, platform: 'shopify' } : null;
  }
  function parseReviews(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    return $$('.jdgm-rev', tmp).map(function (el) {
      var pics = $$('.jdgm-rev__pic-img', el)
        .map(function (img) { return img.getAttribute('data-src') || img.getAttribute('src') || ''; })
        .filter(Boolean);
      var rating = $('.jdgm-rev__rating', el);
      var title = $('.jdgm-rev__title', el);
      var body = $('.jdgm-rev__body', el);
      return {
        rating: rating ? parseInt(rating.getAttribute('data-score') || '0', 10) || 0 : 0,
        text: (title ? cleanText(title) : '') + ' ' + (body ? cleanText(body) : ''),
        photos: pics,
        el: el
      };
    });
  }
  // 一次性拉全部评论；失败就记为 null，不重试（避免每次 DOM 变动都去打接口）
  function fetchAllReviews() {
    if (RF.promise) return RF.promise;
    var w = jdgmWidget();
    var pid = w && (w.getAttribute('data-id') || w.getAttribute('data-product-id'));
    var sp = jdgmParams();
    if (!pid || !sp || !window.fetch || !window.URLSearchParams) return null;
    var all = [];
    function page(n) {
      var q = new URLSearchParams(sp);
      q.set('product_id', pid);
      q.set('page', String(n));
      q.set('per_page', '100');
      return fetch(JDGM_API + '?' + q.toString())
        .then(function (r) {
          if (!r.ok) throw new Error('judge.me ' + r.status);
          return r.json();
        })
        .then(function (j) {
          var got = parseReviews(j.html || '');
          all = all.concat(got);
          var total = parseInt(j.total_count || '0', 10) || 0;
          if (got.length && all.length < total && n < 20) return page(n + 1);
          return all;
        });
    }
    RF.promise = page(1).catch(function () { return null; });
    return RF.promise;
  }

  function kwMatches(kw, rv) {
    return kw.re.test(rv.text);
  }
  function computeCounts(cfg, reviews) {
    cfg.keywords.forEach(function (kw) {
      kw.count = reviews.filter(function (r) { return kwMatches(kw, r); }).length;
    });
    cfg.photosCount = reviews.filter(function (r) { return r.photos.length > 0; }).length;
    // 提到得多的排前面（稳定排序：条数相同保持后台填写顺序）
    cfg.keywords = cfg.keywords
      .map(function (k, i) { return { k: k, i: i }; })
      .sort(function (a, b) { return b.k.count - a.k.count || a.i - b.i; })
      .map(function (x) { return x.k; });
  }
  function filterReviews(cfg, reviews, key) {
    if (key === 'photos') return reviews.filter(function (r) { return r.photos.length > 0; });
    var kw = keywordByKey(cfg, key);
    return kw ? reviews.filter(function (r) { return kwMatches(kw, r); }) : reviews;
  }
  function keywordByKey(cfg, key) {
    return cfg.keywords.filter(function (k) { return k.key === key; })[0] || null;
  }

  // 把命中的词用 <mark> 包起来（只动文本节点，不碰结构）
  function highlight(root, re) {
    if (!root || !re) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var txt = n.nodeValue;
      var frag = document.createDocumentFragment();
      var last = 0;
      var m;
      re.lastIndex = 0;
      while ((m = re.exec(txt))) {
        var start = m.index + m[1].length;
        frag.appendChild(document.createTextNode(txt.slice(last, start)));
        var mk = document.createElement('mark');
        mk.className = 'anora-rf__hl';
        mk.textContent = m[2];
        frag.appendChild(mk);
        last = start + m[2].length;
      }
      if (!last) return;
      frag.appendChild(document.createTextNode(txt.slice(last)));
      n.parentNode.replaceChild(frag, n);
    });
  }
  // 接口返回的缩略图是 width=160（Judge.me 给列表用的小图），可评论卡片实际要显示到 ~300px 宽，
  // 直接拿来用等于放大一倍半，看着就是糊的。原生卡片上的图是 width=396，这里对齐它
  var PIC_WIDTH = 396;
  function bigPic(src) {
    return src.replace(/([?&])width=\d+/, '$1width=' + PIC_WIDTH);
  }
  // 接口返回的是 Judge.me 未初始化的评论 HTML：图片是 data-src、时间是空的，这里补上
  function renderReview(rv, kw) {
    var el = rv.el.cloneNode(true);
    $$('img[data-src]', el).forEach(function (img) {
      if (!img.getAttribute('src')) img.setAttribute('src', bigPic(img.getAttribute('data-src')));
    });
    $$('.jdgm--loading', el).forEach(function (a) { a.classList.remove('jdgm--loading'); });
    // Judge.me 平时靠 .jdgm-rev:not(.jdgm--done-setup) 把这几个块藏着，等自己的脚本填完内容再放出来。
    // 我们为了绕开 leex 的显示门槛手动补了 done-setup 类，接口返回的空壳就会跟着露出来 ——
    // 没有店家回复的评论底下会多出一条粉色空条。这里把确实没内容的直接删掉
    // 注意别把 .jdgm-rev__buyer-badge-wrapper 一起删了：那个 "Verified" 字样是 CSS 生成的，
    // 元素本身没有文字，按下面的判据会被当成空壳误杀
    ['.jdgm-rev__reply', '.jdgm-rev__vids'].forEach(function (sel) {
      $$(sel, el).forEach(function (n) {
        if (!cleanText(n) && !$('img, video, iframe', n) && n.parentNode) n.parentNode.removeChild(n);
      });
    });
    $$('time[datetime]', el).forEach(function (t) {
      var dt = new Date(t.getAttribute('datetime'));
      if (!isNaN(dt.getTime()) && !cleanText(t)) {
        t.textContent = dt.toLocaleDateString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit' });
      }
      t.classList.remove('jdgm-spinner');
    });
    // Judge.me 的 CSS 会把没标"已初始化"的评论整条 display:none，这里照抄它给原生评论打的类
    el.classList.add('anora-rf__rev', 'jdgm--done-setup', 'jdgm--leex-done-setup');
    var native = $('.jdgm-rev-widg__reviews .jdgm-rev');
    if (native) {
      Array.prototype.forEach.call(native.classList, function (c) {
        if (/done-setup/.test(c)) el.classList.add(c);
      });
    }
    if (kw) {
      highlight($('.jdgm-rev__body', el), kw.reAll);
      highlight($('.jdgm-rev__title', el), kw.reAll);
    }
    return el;
  }

  var NATIVE_PARTS = '.jdgm-rev-widg__reviews, .jdgm-paginate, .jdgm-rev-widg__paginate-spinner-wrapper, .jdgm-rev-widg__sort-wrapper';

  function applyFilter(key) {
    var widg = $('.jdgm-rev-widg');
    var bar = widg && $('.anora-rf', widg);
    var list = widg && $('.anora-rf__list', widg);
    var cfg = RF.cfg;
    var reviews = RF.reviews;
    if (!bar || !list || !cfg || !reviews) return false;
    if (!$('[data-anora-rf="' + key + '"]', bar)) key = 'all';
    RF.active = key;
    $$('[data-anora-rf]', bar).forEach(function (b) {
      var on = b.getAttribute('data-anora-rf') === key;
      b.classList.toggle('anora-rf__btn--on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var natives = $$(NATIVE_PARTS, widg);
    if (key === 'all') {
      RF.takeover = false;
      list.hidden = true;
      list.innerHTML = '';
      natives.forEach(function (n) { n.classList.remove('anora-rf-hide'); });
      scheduleRelayout();
      scheduleEnsure();
      return true;
    }
    var kw = keywordByKey(cfg, key);
    var hits = filterReviews(cfg, reviews, key);
    list.innerHTML = '';
    var head = document.createElement('p');
    head.className = 'anora-rf__summary';
    head.textContent = hits.length + ' of ' + reviews.length + ' reviews · ' + (kw ? kw.label : cfg.photosLabel);
    list.appendChild(head);
    hits.forEach(function (r) { list.appendChild(renderReview(r, kw)); });
    list.hidden = false;
    natives.forEach(function (n) { n.classList.add('anora-rf-hide'); });
    return true;
  }

  /* Judge.me 有时候不把评论渲染出来 —— 主题编辑器里最常见（section 一重载它就不再初始化），
     偶尔前台脚本没跑完也会这样。表现就是：筛选条在、底下一片空白。
     这里兜底：接口的数据我们本来就全拿到了，自己渲染出来；等它缓过来再交还给它。 */
  var TAKEOVER_STEP = 10;
  function nativeShownCount(widg) {
    var nat = $('.jdgm-rev-widg__reviews', widg);
    if (!nat) return 0;
    return $$('.jdgm-rev', nat).filter(function (r) { return r.offsetHeight > 0; }).length;
  }
  function appendTakeover(list) {
    var oldMore = $('.anora-rf__more', list);
    if (oldMore) oldMore.parentNode.removeChild(oldMore);
    RF.reviews.slice(RF.shown, RF.shown + TAKEOVER_STEP).forEach(function (r) {
      list.appendChild(renderReview(r, null));
      RF.shown += 1;
    });
    if (RF.shown < RF.reviews.length) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'anora-rf__more';
      btn.textContent = 'Show more reviews';
      btn.addEventListener('click', function () { appendTakeover(list); });
      list.appendChild(btn);
    }
  }
  function ensureAllVisible() {
    if (RF.active !== 'all') return;
    var widg = $('.jdgm-rev-widg');
    var list = widg && $('.anora-rf__list', widg);
    if (!widg || !list) return;
    var nat = $('.jdgm-rev-widg__reviews', widg);
    if (nat) nat.classList.remove('anora-rf-hide'); // 先放开，否则量不到真实高度
    if (nativeShownCount(widg) > 0) {
      if (RF.takeover) { // 它自己缓过来了，把位置让回去
        RF.takeover = false;
        list.hidden = true;
        list.innerHTML = '';
        $$(NATIVE_PARTS, widg).forEach(function (n) { n.classList.remove('anora-rf-hide'); });
        scheduleRelayout();
      }
      return;
    }
    if (RF.takeover || !RF.reviews || !RF.reviews.length) return;
    RF.takeover = true;
    RF.shown = 0;
    list.innerHTML = '';
    appendTakeover(list);
    list.hidden = false;
    // 原生那份是空的，连它的排序/翻页一起收起来，免得点了没反应
    $$(NATIVE_PARTS, widg).forEach(function (n) { n.classList.add('anora-rf-hide'); });
  }
  /* Judge.me 的 leex 主题用 Masonry 把评论卡片绝对定位，容器高度是排版那一刻写死的。
     上面兜底时原生列表被 display:none 过，它若恰好在这时排版，卡片全叠在 top:0、容器高 0；
     评论图后加载、卡片变高也不会自己重排 —— 两种情况都会让评论压到下面的 FAQ / 推荐商品上。
     所以卡片尺寸一变（包括从藏着变回显示）就让它重排一次 */
  var relayoutTimer = 0;
  function relayoutNative() {
    var nat = $('.jdgm-rev-widg__reviews');
    var jq = window.jdgm && window.jdgm.$;
    if (!nat || !nat.getClientRects().length) return; // 藏着的时候排出来全是 0，等放出来再排
    if (!jq || !jq.fn || !jq.fn.masonry || !jq(nat).data('masonry')) return;
    jq(nat).masonry('layout');
  }
  function scheduleRelayout() {
    clearTimeout(relayoutTimer);
    relayoutTimer = setTimeout(relayoutNative, 120);
  }
  var cardObserver = window.ResizeObserver ? new ResizeObserver(scheduleRelayout) : null;
  function watchNativeCards() {
    if (!cardObserver) return;
    $$('.jdgm-rev-widg__reviews > .jdgm-rev').forEach(function (card) {
      if (card.__anoraWatched) return;
      card.__anoraWatched = true;
      cardObserver.observe(card);
    });
  }

  // 页面刚加载时 Judge.me 往往还没渲染完，隔几拍再确认，别一上来就抢
  function scheduleEnsure() {
    (RF.ensureTimers || []).forEach(clearTimeout);
    RF.ensureTimers = [0, 700, 1800, 4000].map(function (d) { return setTimeout(ensureAllVisible, d); });
  }

  // 评论列表正上方的筛选条
  function initReviewFilter() {
    var cfg = RF.cfg;
    var reviews = RF.reviews;
    var widg = $('.jdgm-rev-widg');
    var body = widg && $('.jdgm-rev-widg__body', widg);
    if (!widg || !body) return;
    var bar = $('.anora-rf', widg);
    if (!cfg || !reviews || !cfg.filterBar) {
      if (bar) bar.remove();
      return;
    }
    var items = [{ key: 'all', label: cfg.allLabel, count: reviews.length }];
    if (cfg.photosFilter && cfg.photosCount) items.push({ key: 'photos', label: cfg.photosLabel, count: cfg.photosCount });
    cfg.keywords.forEach(function (k) {
      if (k.count) items.push({ key: k.key, label: k.label, count: k.count });
    });
    if (items.length < 2) {
      if (bar) bar.remove();
      return;
    }
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'anora-rf';
      bar.innerHTML = '<span class="anora-rf__label">Filter</span><div class="anora-rf__btns" role="group" aria-label="Filter reviews"></div>';
      body.parentNode.insertBefore(bar, body);
      bar.addEventListener('click', function (e) {
        var b = e.target.closest('[data-anora-rf]');
        if (b) applyFilter(b.getAttribute('data-anora-rf'));
      });
    }
    var sig = items.map(function (i) { return i.key + ':' + i.count; }).join('|');
    if (bar.dataset.anoraSig !== sig) {
      bar.dataset.anoraSig = sig;
      var btns = $('.anora-rf__btns', bar);
      btns.innerHTML = '';
      items.forEach(function (i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'anora-rf__btn';
        b.setAttribute('data-anora-rf', i.key);
        b.appendChild(document.createTextNode(i.label));
        var n = document.createElement('b');
        n.textContent = i.count;
        b.appendChild(n);
        btns.appendChild(b);
      });
    }
    var list = $('.anora-rf__list', body);
    if (!list) {
      list = document.createElement('div');
      list.className = 'anora-rf__list';
      list.hidden = true;
      body.insertBefore(list, body.firstChild);
    }
    if (widg.dataset.anoraRfBound !== '1') {
      widg.dataset.anoraRfBound = '1';
      // 用户点了 Judge.me 自己的星级筛选，就退出我们的关键词筛选，避免两套叠着
      widg.addEventListener('click', function (e) {
        if (RF.active !== 'all' && e.target.closest('.jdgm-histogram__row')) applyFilter('all');
      });
    }
    applyFilter(RF.active);
  }

  function jdgmPhotos() {
    if (RF.reviews) {
      var out = [];
      RF.reviews.forEach(function (r) {
        r.photos.forEach(function (src) { out.push(src.replace(/([?&])width=\d+/, '$1width=320')); });
      });
      return out;
    }
    var sels = [
      '.jdgm-rev-widg .jdgm-rev__pic-img',
      '.jdgm-rev-widg .jdgm-rev__pics img',
      '.jdgm-widget .jdgm-rev__pic-img',
      '.jdgm-gallery__thumbnail img'
    ];
    var seen = {};
    var list = [];
    sels.forEach(function (s) {
      $$(s).forEach(function (img) {
        var src = img.getAttribute('data-src') || img.currentSrc || img.src || '';
        if (!src || seen[src]) return;
        seen[src] = 1;
        list.push(src);
      });
    });
    return list;
  }

  function jdgmStats() {
    var badge = $('.jdgm-widget.jdgm-preview-badge .jdgm-prev-badge');
    var count = 0;
    var avg = 0;
    if (badge) {
      count = parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10) || 0;
      avg = parseFloat(badge.getAttribute('data-average-rating') || '0') || 0;
    }
    if (!count) {
      var t = $('.jdgm-prev-badge__text');
      var m = t && (t.textContent || '').match(/(\d+)/);
      if (m) count = parseInt(m[1], 10);
    }
    return { count: count, avg: avg };
  }

  // 画廊里的关键词：展示名 + 真实条数；0 条的不显示
  function renderChips(cfg) {
    var wrap = $('[data-anora-rg-chips]', cfg.box);
    if (!wrap) return;
    var loaded = !!RF.reviews;
    var items = cfg.keywords.filter(function (k) { return !loaded || k.count > 0; }).slice(0, cfg.maxChips);
    var canFilter = loaded && cfg.filterBar && cfg.chipAction === 'filter';
    var sig = items.map(function (k) { return k.label + ':' + k.count; }).join('|') + (canFilter ? '#f' : '#d') + (cfg.showCounts ? '#c' : '');
    if (wrap.dataset.anoraSig === sig) return;
    wrap.dataset.anoraSig = sig;
    wrap.innerHTML = '';
    wrap.hidden = !items.length;
    items.forEach(function (k) {
      var c = document.createElement(canFilter ? 'button' : 'span');
      c.className = 'anora-rg__chip' + (canFilter ? ' anora-rg__chip--btn' : '');
      if (canFilter) {
        c.type = 'button';
        c.setAttribute('data-anora-rg-filter', k.key);
      }
      c.appendChild(document.createTextNode(k.label));
      if (loaded && cfg.showCounts) {
        var b = document.createElement('b');
        b.textContent = k.count;
        c.appendChild(b);
      }
      wrap.appendChild(c);
    });
  }

  function renderGallery(cfg) {
    var box = cfg.box;
    var photos = jdgmPhotos();
    var st = jdgmStats();

    if (!photos.length) {
      box.hidden = true;
      return;
    }

    renderChips(cfg);

    var tiles = $('[data-anora-rg-tiles]', box);
    var sig = photos.slice(0, 3).join('|') + '#' + photos.length + '#' + st.count;
    if (box.dataset.anoraSig === sig) {
      box.hidden = false;
      return;
    }
    box.dataset.anoraSig = sig;

    var cnt = $('[data-anora-rg-count]', box);
    if (cnt) cnt.textContent = st.count ? '(' + st.count + ')' : '';

    if (st.avg > 0) {
      var scoreBox = $('[data-anora-rg-score]', box);
      var full = Math.round(st.avg);
      $('[data-anora-rg-stars]', box).textContent = '★★★★★'.slice(0, full) + '☆☆☆☆☆'.slice(0, 5 - full);
      $('[data-anora-rg-num]', box).textContent = st.avg.toFixed(1);
      if (scoreBox) scoreBox.hidden = false;
    }

    tiles.innerHTML = '';
    photos.slice(0, 3).forEach(function (src) {
      var d = document.createElement('div');
      d.className = 'anora-rg__tile';
      var im = document.createElement('img');
      im.src = src;
      im.loading = 'lazy';
      im.alt = '';
      d.appendChild(im);
      tiles.appendChild(d);
    });
    var more = document.createElement('div');
    more.className = 'anora-rg__tile anora-rg__tile--more';
    more.setAttribute('role', 'button');
    more.setAttribute('tabindex', '0');
    // 店主 2026-09-18：第四格统一写 More Reviews，点了直接跳到下面的评论区（不再自动只看带图的）
    more.setAttribute('data-anora-rg-jump', '');
    more.innerHTML = '<span>More Reviews</span>';
    tiles.appendChild(more);

    if (box.dataset.anoraRgBound !== '1') {
      box.dataset.anoraRgBound = '1';
      box.addEventListener('click', function (e) {
        var f = e.target.closest('[data-anora-rg-filter]');
        var j = e.target.closest('[data-anora-rg-jump]');
        if (!f && !j) return;
        if (f) applyFilter(f.getAttribute('data-anora-rg-filter'));
        scrollToReviews();
      });
      box.addEventListener('keydown', function (e) {
        if (keyActivates(e) && e.target.closest('[data-anora-rg-jump], [data-anora-rg-filter]')) {
          e.preventDefault();
          e.target.click();
        }
      });
    }

    box.hidden = false;
  }

  function initReviewGallery() {
    var cfg = rgConfig();
    if (!cfg) return false;
    if (RF.reviews) computeCounts(cfg, RF.reviews);
    RF.cfg = cfg;

    var p = fetchAllReviews();
    if (p && !RF.waiting) {
      RF.waiting = true;
      p.then(function (reviews) {
        if (reviews && reviews.length) RF.reviews = reviews;
        initReviewGallery();
      });
    }

    renderGallery(cfg);
    initReviewFilter();
    return true;
  }

  /* ---------- ⑦ 手机端顶部 Overview / Reviews / Details 跳转条（对齐 ilike） ----------
     插进页头那个 sticky 的 .section-header 里，跟着页头一起吊在顶上。
     页面刚打开时不占位，往下滑一段才出现 */
  var MTABS = [
    { key: 'overview', label: 'Overview' },
    { key: 'reviews', label: 'Reviews' },
    { key: 'details', label: 'Details' }
  ];
  var mtabBar = null;
  function mtabTarget(key) {
    // Reviews 指向评论图片画廊（它的标题就是 Customer Reviews，且排在描述前面），
    // 没有画廊时退回 Judge.me 的评论块
    if (key === 'reviews') return $('.anora-rg') || reviewTarget();
    if (key === 'details') return $('.anora-acc-head') || $('.product__description');
    return null;
  }
  function mtabOffset() {
    var host = $('.section-header');
    return Math.round(host ? host.getBoundingClientRect().height : 0) + 8;
  }
  function initMobileTabs() {
    var host = $('.section-header');
    if (!host) return false;
    if (mtabBar && mtabBar.parentNode === host) return true;
    mtabBar = $('.anora-mtabs', host);
    if (!mtabBar) {
      mtabBar = document.createElement('nav');
      mtabBar.className = 'anora-mtabs';
      mtabBar.setAttribute('aria-label', 'Product sections');
      MTABS.forEach(function (t, i) {
        var a = document.createElement('a');
        a.className = 'anora-mtab' + (i === 0 ? ' is-active' : '');
        a.href = '#';
        a.setAttribute('data-anora-mtab', t.key);
        a.textContent = t.label;
        mtabBar.appendChild(a);
      });
      mtabBar.addEventListener('click', function (e) {
        var a = e.target && e.target.closest ? e.target.closest('[data-anora-mtab]') : null;
        if (!a) return;
        e.preventDefault();
        var key = a.getAttribute('data-anora-mtab');
        if (key === 'overview') {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }
        var el = mtabTarget(key);
        if (!el) return;
        window.scrollTo({
          top: el.getBoundingClientRect().top + window.pageYOffset - mtabOffset(),
          behavior: 'smooth'
        });
      });
      host.appendChild(mtabBar);
    }
    updateMobileTabs();
    return true;
  }
  function updateMobileTabs() {
    if (!mtabBar || !mtabBar.parentNode) return;
    var on = MOBILE.matches && window.pageYOffset > 280;
    mtabBar.classList.toggle('anora-mtabs--on', on);
    if (!on) return;
    var line = mtabOffset() + 12;
    var key = 'overview';
    // 顺序就是页面上的先后：画廊在描述前面
    ['reviews', 'details'].forEach(function (k) {
      var el = mtabTarget(k);
      if (el && el.getBoundingClientRect().top <= line) key = k;
    });
    $$('[data-anora-mtab]', mtabBar).forEach(function (a) {
      a.classList.toggle('is-active', a.getAttribute('data-anora-mtab') === key);
    });
  }

  /* ============================================================
     启动 + 自愈
     Judge.me 异步、Dawn 换变体重渲染 —— 都靠这里兜住
     ============================================================ */
  function initAll() {
    initReviewLink();
    initDescription();
    initStickyAtc();
    initReviewGallery();
    initMobileTabs();
    watchNativeCards();
  }

  onReady(function () {
    if (!$('.product__info-container, product-form')) return; // 只在商品页跑

    initAll();

    var t = 0;
    var mo = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        initReviewLink();
        initDescription();
        initReviewGallery();
        initMobileTabs();
        watchNativeCards();
        var btn = realSubmit();
        if (btn && (!btn.dataset.anoraObserved || !document.body.contains(stickyBar))) {
          btn.dataset.anoraObserved = '1';
          initStickyAtc();
        }
        syncStickyBar();
        updateSticky();
      }, 180);
    });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled'] });

    window.addEventListener('load', initAll);

    if (MOBILE.addEventListener) {
      MOBILE.addEventListener('change', function () {
        applyAccMode();
        updateSticky();
        updateMobileTabs();
      });
    }
  });
})();
